module.exports = __webpack_public_path__ + "static/media/accessDenied.bb80af37.png";